import axios from "../axios-auth";

export const supplierProductService = {
    getAllProductBySupplier,
    getAllProductBySupplierAndWarehouse
};


function getAllProductBySupplier(searchParams, page, size) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size
    };

    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }

    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }

    if (searchParams.productGroupName) {
        params["productGroupName"] = searchParams.productGroupName;
    }

    if (searchParams.supplierId) {
        params["supplierId"] = searchParams.supplierId;
    }

    return axios.get("/auth/all-products-by-supplier", { params });
}

function getAllProductBySupplierAndWarehouse(searchParams, page, size) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size
    };

    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }

    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }

    if (searchParams.productGroupName) {
        params["productGroupName"] = searchParams.productGroupName;
    }

    if (searchParams.supplierId) {
        params["supplierId"] = searchParams.supplierId;
    }

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (searchParams.isPurchase) {
        params["isPurchase"] = searchParams.isPurchase;
    }

    if (searchParams.isSale) {
        params["isSale"] = searchParams.isSale;
    }

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    if (searchParams.orderWarehouseId) {
        params["orderWarehouseId"] = searchParams.orderWarehouseId;
    }

    if (searchParams.orderEditId) {
        params["orderEditId"] = searchParams.orderEditId;
    }

    if (searchParams.pricemodelId) {
        params["pricemodelId"] = searchParams.pricemodelId;
    }

    return axios.get("/auth/all-products-by-supplier-and-warehouse", { params });

}
